export default __webpack_public_path__ + "static/media/bsc-logo.813e0020.svg";